import { tipoIntermediador } from "../dynamicTextRegistry";
import { maskCpf, maskPhoneBr } from "../../utils/masks";

function formatCpfPreview(value) {
  return maskCpf(value ?? "");
}

function formatPhonePreview(value) {
  return maskPhoneBr(value ?? "");
}

function formatDateBR(value) {
  if (!value) return "";
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split("-").map(Number);
    const dt = new Date(y, m - 1, d);
    if (!Number.isNaN(dt.getTime())) return dt.toLocaleDateString("pt-BR");
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return s;
  return parsed.toLocaleDateString("pt-BR");
}

function escapeHtml(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function replacePlaceholdersInStringEscaped(template, values) {
  if (!template) return "";
  return template.replace(/\{(.*?)\}/g, (_, key) =>
    escapeHtml(values[key] ?? "")
  );
}

function buildCorretorBlockHtml(person) {
  const template = tipoIntermediador.corretor;
  if (!template) return "";

  const values = {
    ...person,
    CPF_CORRETOR: formatCpfPreview(person.CPF_CORRETOR),
    TEL_CORRETOR: formatPhonePreview(person.TEL_CORRETOR),
  };

  const raw = replacePlaceholdersInStringEscaped(template.trim(), values);
  return `<p class="text-justify whitespace-pre-line">${raw}</p>`;
}

function signatureBlock(name, cpf) {
  return `________________________\n${name ?? ""}\n${formatCpfPreview(cpf)}`;
}

export function contratoParceriaVendasResolver(formData, userConfig) {
  const safeUserConfig = userConfig || {};
  const data = { ...safeUserConfig, ...formData };

  data.ENDERECO_IMOBILIARIA =
    formData.ENDERECO_IMOBILIARIA !== undefined &&
    formData.ENDERECO_IMOBILIARIA !== null
      ? formData.ENDERECO_IMOBILIARIA
      : safeUserConfig.endereco_imobiliaria || "";
  data.CELULAR_IMOBILIARIA = formatPhonePreview(
    formData.CELULAR_IMOBILIARIA !== undefined &&
      formData.CELULAR_IMOBILIARIA !== null
      ? formData.CELULAR_IMOBILIARIA
      : safeUserConfig.celular_imobiliaria || ""
  );
  data.EMAIL_IMOBILIARIA =
    formData.EMAIL_IMOBILIARIA !== undefined &&
    formData.EMAIL_IMOBILIARIA !== null
      ? formData.EMAIL_IMOBILIARIA
      : safeUserConfig.email_imobiliaria || "";
  data.CRECI_IMOBILIARIA =
    formData.CRECI_IMOBILIARIA !== undefined &&
    formData.CRECI_IMOBILIARIA !== null
      ? formData.CRECI_IMOBILIARIA
      : safeUserConfig.creci_imobiliaria || "";
  data.SITE_IMOBILIARIA =
    formData.SITE_IMOBILIARIA !== undefined &&
    formData.SITE_IMOBILIARIA !== null
      ? formData.SITE_IMOBILIARIA
      : safeUserConfig.site_imobiliaria || "";

  if (formData.captantes?.length) {
    data.CAPTANTES = formData.captantes
      .map((v) => buildCorretorBlockHtml(v))
      .join("");
    data.ASSINATURA_CAPTANTES = formData.captantes
      .map((v) => signatureBlock(v.NOME_CORRETOR, v.CPF_CORRETOR))
      .join("\n\n");
  }

  if (formData.intermediadores?.length) {
    data.INTERMEDIADORES = formData.intermediadores
      .map((c) => buildCorretorBlockHtml(c))
      .join("");
    data.ASSINATURA_INTERMEDIADORES = formData.intermediadores
      .map((c) => signatureBlock(c.NOME_CORRETOR, c.CPF_CORRETOR))
      .join("\n\n");
  }

  if (formData.testemunhas?.length) {
    data.ASSINATURA_TESTEMUNHAS = formData.testemunhas
      .map((t) => signatureBlock(t.NOME_TESTEMUNHA, t.CPF_TESTEMUNHA))
      .join("\n\n");
  }

  if (data.DATA_ASSINATURA) {
    data.DATA_ASSINATURA = formatDateBR(data.DATA_ASSINATURA);
  }

  return data;
}
